module.exports = __webpack_public_path__ + "static/media/mini-SB.6c460f9b.svg";